export const wellKnownURLParams = {
  // URL params we add to pass state around during the login flow.
  clientId: 'state_cid',
  connection: 'state_conn',
  // This is used to force the use of a connection.
  // We typically use for the support connection.
  connectionOverride: 'authconn',
};
